import { installAppearance } from '~/lib/settings/appearance'

// Accent color, font size and density from Settings → «Внешний вид», applied before the first
// render so the app doesn't flash in the defaults first — see lib/settings/appearance.ts.
export default defineNuxtPlugin(() => {
  installAppearance()
})
